import { render } from "./destination-stop-area.vue?vue&type=template&id=61f35d9a"
import script from "./destination-stop-area.vue?vue&type=script&lang=js"
export * from "./destination-stop-area.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__